import React from 'react';
import camping from '../assets/portfolio/camping.jpeg';
import rgba from '../assets/portfolio/rgba.jpeg';
import JournalGallery from '../assets/portfolio/journal.png';
import patt from '../assets/portfolio/patt.png';
import weather from "../assets/portfolio/ww.jpeg";
import task from "../assets/portfolio/task.png";


const Projects = () => {

  const project= [
    {
      id:1,
      src:camping,
      demo:"https://camping-sites.onrender.com",
      code:"https://github.com/Rishika30/Yelp_camp"
    },
    {
      id:2,
      src:rgba,
      demo:"https://rgba-colorgame-app.netlify.app/",
      code:"https://github.com/Rishika30/colorgame"
    },
    {
      id:3,
      src:JournalGallery,
      demo:"#",
      code:"https://github.com/Rishika30/JournalGallery"
    },
    {
      id:4,
      src:patt,
      demo:"https://patatap-clone-seven.vercel.app/circles.html",
      code:"https://github.com/Rishika30/patatap-clone"
    },
    {
      id:4,
      src:weather,
      demo:"#",
      code:"https://github.com/Rishika30/WeatherApp"
    },
    {
      id:5,
      src:task,
      demo:"#",
      code:"https://github.com/Rishika30/task-management-app"
    }
  ]
  return <div name= "portfolio" className='bg-gradient-to-b from-slate-800 to-gray-500 w-full text-white md:h-screen'>
    <div className='max-w-screen-lg p-4 mx-auto flex flex-col justify-center w-full h-full'>
    <div className='pb-8'>
      <p className='text-4xl font-bold inline border-b-4 border-gray-500'>Projects</p>
      <p className='py-6 text-2xl'>These are some of my projects-</p>
    </div>

<div className='grid sm:grid-cols-2 md:grid-cols-3 gap-8 px-12 sm:px-0'>

{
 project.map(({id, src, demo,code}) => (
  <div key={id} className='shadow-md shadow-black rounded-lg'>
    <img src={src} alt="" className='rounded-md duration-200 hover:scale-105' />
    <div className='flex items-center justify-center'>
    <a href={demo}>
      <button className='w-1/2 px-6 py-3 m-4 duration-200 hover:scale:105' >Demo</button>
    </a>
    <a href={code}>
      <button className='w-1/2 px-6 py-3 m-4 duration-200 hover:scale:105'>Code</button>
    </a>

    </div>
  </div>
))
}
</div>
  
      </div>
      </div>;

};

export default Projects
